import { wixImg } from "../data/projects";
import { useSEO } from "../lib/seo";

const team = [
  {
    name: "FÜLÖP ZOLTÁN",
    role: "Vezető tervező, ügyvezető",
    text: "Vezető tervezőként és ügyvezetőként célom, hogy minden projektben olyan építészeti megoldások szülessenek, amelyek harmonikusan egyesítik a funkciót, az esztétikát és a használhatóságot. Széleskörű szakmai tapasztalattal irányítom a tervezési és kivitelezési folyamatokat, és nagy hangsúlyt fektetek az együttműködésre, a folyamatos egyeztetésre és a személyre szabott szakmai támogatásra.",
    img: "58bce5_1568d7db3a3f4e769ca45759dcb6f8ee~mv2.jpg",
  },
  {
    name: "SZABÓ NORBERT",
    role: "Építész tervező",
    text: "Építész tervezőként a tervezési folyamat minden fázisában aktívan részt veszek, a koncepcióalkotástól a részletes műszaki kidolgozásig. Munkám során kiemelt figyelmet fordítok a funkcionális térszervezésre, az átgondolt alaprajzi logikára és a megvalósítható, hosszú távon is értékálló építészeti megoldásokra. A projektekben precíz, együttműködő és következetes szakmai hozzáállással támogatom a tervezői csapat munkáját.",
    img: "58bce5_b2b0012c76f04379b986bed3c6ed6149~mv2.jpeg",
  },
  {
    name: "BALOGH BENCE",
    role: "Belsőépítész",
    text: "Építész végzettséggel rendelkező belsőépítészként a tervezés során a térstruktúra, az anyaghasználat és a részletképzés egységére törekszem. Munkámban fontos szerepet kap a funkcionális térkialakítás, a letisztult esztétikai megjelenés és a hosszú távon is értékálló, időtálló belsőépítészeti karakter kialakítása.",
    img: "58bce5_23c4bd38671a4b16b0fbaad87871a4c2~mv2.jpg",
  },
  {
    name: "MEZEI BALÁZS",
    role: "Tartószerkezet-tervező mérnök",
    text: "Tartószerkezet-tervező mérnökként feladatom a projektek statikai és szerkezeti rendszerének kialakítása, az építészeti koncepcióval összhangban. Tervezői munkámat a mérnöki precizitás, a felelős műszaki gondolkodás és a költséghatékony szerkezeti megoldásokra való törekvés határoz meg.",
    img: "58bce5_35151187411b4cb7bfc33e5a5625ce2f~mv2.jpg",
  },
  {
    name: "SÓS IMRE",
    role: "Gépész tervező mérnök",
    text: "Gépész tervező mérnökként munkám középpontjában a korszerű, energiahatékony és fenntartható épületgépészeti megoldások kialakítása áll. Tervezői szemléletemet a precíz műszaki részletképzés, a megbízható rendszerintegráció és a komfortos belső környezeti feltételek biztosítása határozza meg.",
    img: "58bce5_eccef39730744f388f8af4a7827c2b72~mv2.jpg",
  },
];

const Rolunk = () => {
  useSEO(
    "Rólunk – Építész csapatunk | New Idea Architect",
    "Ismerd meg a New Idea Architect csapatát: építészek, belsőépítész, tartószerkezeti és gépész tervező mérnökök – egy kézben minden szakág.",
    "/rolunk"
  );
  return (
    <main className="flex flex-col gap-2.5 pb-2.5">
      <section className="px-2.5">
        <div className="rounded-2xl bg-[var(--accent)] p-8 sm:p-12">
          <h1 className="text-black heading-font font-bold text-5xl sm:text-6xl lg:text-7xl tracking-tight">Rólunk</h1>
          <p className="text-black font-semibold mt-4 max-w-lg">
            A New Idea Architect csapata – építészek és mérnökök, akik az első gondolattól a kulcsrakész átadásig kísérik a projekteket.
          </p>
        </div>
      </section>

      {team.map((m, i) => (
        <section key={m.name} className="px-2.5">
          <div className={`grid grid-cols-1 gap-2.5 ${i % 2 === 1 ? "lg:grid-cols-[1fr_2fr]" : "lg:grid-cols-[2fr_1fr]"}`}>
            <div className={`rounded-2xl bg-[var(--card-dark)] border border-white/10 p-8 sm:p-12 flex flex-col justify-center ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <p className="text-[var(--accent)] text-xs font-bold tracking-[0.2em] mb-3 uppercase">{m.role}</p>
              <h2 className="text-white heading-font font-bold text-4xl sm:text-5xl tracking-tight leading-[1.05]">{m.name}</h2>
              <p className="text-white/85 text-base leading-7 mt-6 max-w-2xl">{m.text}</p>
            </div>
            <div className={`rounded-2xl overflow-hidden group aspect-[3/4] bg-[var(--card-dark)] ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <img
                src={wixImg(m.img, 800)}
                alt={m.name}
                loading={i === 0 ? "eager" : "lazy"}
                decoding="async"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </section>
      ))}
    </main>
  );
};

export default Rolunk;
